module.exports = __webpack_public_path__ + "img/blockquote-right.a43cfb22.svg";